// extracted by mini-css-extract-plugin
export default {"content":"wma-z","title":"xma-z","subTitle":"yma-z","banner":"zma-z","productCardOverride":"Ama-z"};